import React, { FC } from 'react';
import { IconProps } from './index';

export const Italic: FC<IconProps> = ({ color = '#FFFFFF', size = 24 }) => {
  return <svg width={size} height={size} viewBox="0 0 20 20" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M11.0944 16H7L7.07997 15.5029C7.54912 15.2971 8.00762 15.16 8.45545 15.0914L10.4547 4.92571C10.2414 4.88 10.0388 4.82286 9.84692 4.75429C9.65499 4.67429 9.45773 4.58857 9.25514 4.49714L9.3671 4H13.4615L13.3656 4.49714C13.1523 4.58857 12.9231 4.67429 12.6778 4.75429C12.4326 4.82286 12.2034 4.88 11.9901 4.92571L9.99086 15.0914C10.2041 15.1371 10.412 15.1943 10.6146 15.2629C10.8279 15.3314 11.0145 15.4114 11.1744 15.5029L11.0944 16Z"/>
  </svg>;
};
